export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const START = 'START';
export const SET = 'SET';
export const SAVE = 'SAVE';
export const ADD = 'ADD';
export const REMOVE = 'REMOVE';
export const RESET = 'RESET';
